export default __webpack_public_path__ + "static/media/nutri4.3a31f74c.jpeg";